/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAdminHomeRouteImport } from './routes/_authenticated/admin-home'
import { Route as AuthenticatedDashboardRouteRouteImport } from './routes/_authenticated/dashboard/route'
import { Route as AuthenticatedMemberHomeRouteImport } from './routes/_authenticated/member-home'
import { Route as AuthenticatedMembershipsRouteRouteImport } from './routes/_authenticated/memberships/route'
import { Route as AuthenticatedMyCheckInsRouteImport } from './routes/_authenticated/my-check-ins'
import { Route as AuthenticatedMyMembershipRouteImport } from './routes/_authenticated/my-membership'
import { Route as AuthenticatedMyPaymentsRouteImport } from './routes/_authenticated/my-payments'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedTrainersRouteRouteImport } from './routes/_authenticated/trainers/route'
import { Route as AuthenticatedAppsIndexRouteImport } from './routes/_authenticated/apps/index'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedCheckInsByDateRouteImport } from './routes/_authenticated/check-ins/by-date'
import { Route as AuthenticatedCheckInsDeniedAlertsRouteImport } from './routes/_authenticated/check-ins/denied-alerts'
import { Route as AuthenticatedCheckInsQrRouteImport } from './routes/_authenticated/check-ins/qr'
import { Route as AuthenticatedCheckInsQrCheckoutRouteImport } from './routes/_authenticated/check-ins/qr-checkout'
import { Route as AuthenticatedCheckInsRutRouteImport } from './routes/_authenticated/check-ins/rut'
import { Route as AuthenticatedCheckInsRutCheckoutRouteImport } from './routes/_authenticated/check-ins/rut-checkout'
import { Route as AuthenticatedCheckInsTrainerAttentionRouteImport } from './routes/_authenticated/check-ins/trainer-attention'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardAnalyticsRouteImport } from './routes/_authenticated/dashboard/analytics'
import { Route as AuthenticatedDashboardAttendanceDetailsRouteImport } from './routes/_authenticated/dashboard/attendance-details'
import { Route as AuthenticatedDashboardExitLimitCheckInsRouteImport } from './routes/_authenticated/dashboard/exit-limit-check-ins'
import { Route as AuthenticatedDashboardMembershipExpirationsRouteImport } from './routes/_authenticated/dashboard/membership-expirations'
import { Route as AuthenticatedDashboardOverviewRouteImport } from './routes/_authenticated/dashboard/overview'
import { Route as AuthenticatedDashboardPlansAnalyticsRouteImport } from './routes/_authenticated/dashboard/plans-analytics'
import { Route as AuthenticatedDashboardRepeatedCheckInsRouteImport } from './routes/_authenticated/dashboard/repeated-check-ins'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedMembershipsIndexRouteImport } from './routes/_authenticated/memberships/index'
import { Route as AuthenticatedMembershipsCompensationsRouteImport } from './routes/_authenticated/memberships/compensations'
import { Route as AuthenticatedMembershipsDayPassTypesRouteImport } from './routes/_authenticated/memberships/day-pass-types'
import { Route as AuthenticatedMembershipsManageTypesRouteImport } from './routes/_authenticated/memberships/manage-types'
import { Route as AuthenticatedMembershipsWithoutMembershipRouteImport } from './routes/_authenticated/memberships/without-membership'
import { Route as AuthenticatedPaymentsIndexRouteImport } from './routes/_authenticated/payments/index'
import { Route as AuthenticatedPersonalizedPlansIndexRouteImport } from './routes/_authenticated/personalized-plans/index'
import { Route as AuthenticatedQrCodesIndexRouteImport } from './routes/_authenticated/qr-codes/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsBusinessRouteImport } from './routes/_authenticated/settings/business'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsRolesRouteImport } from './routes/_authenticated/settings/roles'
import { Route as AuthenticatedSettingsTrainerProfileRouteImport } from './routes/_authenticated/settings/trainer-profile'
import { Route as AuthenticatedSystemCheckInsRouteImport } from './routes/_authenticated/system/check-ins'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedTrainerIndexRouteImport } from './routes/_authenticated/trainer/index'
import { Route as AuthenticatedTrainerAssignRouteImport } from './routes/_authenticated/trainer/assign'
import { Route as AuthenticatedTrainerAttentionRouteImport } from './routes/_authenticated/trainer/attention'
import { Route as AuthenticatedTrainerStudentsRouteImport } from './routes/_authenticated/trainer/students'
import { Route as AuthenticatedTrainersIndexRouteImport } from './routes/_authenticated/trainers/index'
import { Route as AuthenticatedTrainersAssignRouteImport } from './routes/_authenticated/trainers/assign'
import { Route as AuthenticatedTrainersAttentionReportRouteImport } from './routes/_authenticated/trainers/attention-report'
import { Route as AuthenticatedTrainersBlockedRouteImport } from './routes/_authenticated/trainers/blocked'
import { Route as AuthenticatedTrainersNewRouteImport } from './routes/_authenticated/trainers/new'
import { Route as AuthenticatedTrainersStudentsRouteImport } from './routes/_authenticated/trainers/students'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedProfileQrCodeIndexRouteImport } from './routes/_authenticated/profile.qr-code/index'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/(auth)/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAdminHomeRoute = AuthenticatedAdminHomeRouteImport.update({
  id: '/admin-home',
  path: '/admin-home',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDashboardRouteRoute =
  AuthenticatedDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMemberHomeRoute = AuthenticatedMemberHomeRouteImport.update({
  id: '/member-home',
  path: '/member-home',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMembershipsRouteRoute =
  AuthenticatedMembershipsRouteRouteImport.update({
    id: '/memberships',
    path: '/memberships',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMyCheckInsRoute = AuthenticatedMyCheckInsRouteImport.update({
  id: '/my-check-ins',
  path: '/my-check-ins',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMyMembershipRoute =
  AuthenticatedMyMembershipRouteImport.update({
    id: '/my-membership',
    path: '/my-membership',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMyPaymentsRoute = AuthenticatedMyPaymentsRouteImport.update({
  id: '/my-payments',
  path: '/my-payments',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTrainersRouteRoute =
  AuthenticatedTrainersRouteRouteImport.update({
    id: '/trainers',
    path: '/trainers',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAppsIndexRoute = AuthenticatedAppsIndexRouteImport.update({
  id: '/apps/',
  path: '/apps/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCheckInsByDateRoute =
  AuthenticatedCheckInsByDateRouteImport.update({
    id: '/check-ins/by-date',
    path: '/check-ins/by-date',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCheckInsDeniedAlertsRoute =
  AuthenticatedCheckInsDeniedAlertsRouteImport.update({
    id: '/check-ins/denied-alerts',
    path: '/check-ins/denied-alerts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCheckInsQrRoute = AuthenticatedCheckInsQrRouteImport.update({
  id: '/check-ins/qr',
  path: '/check-ins/qr',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCheckInsQrCheckoutRoute =
  AuthenticatedCheckInsQrCheckoutRouteImport.update({
    id: '/check-ins/qr-checkout',
    path: '/check-ins/qr-checkout',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCheckInsRutRoute =
  AuthenticatedCheckInsRutRouteImport.update({
    id: '/check-ins/rut',
    path: '/check-ins/rut',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCheckInsRutCheckoutRoute =
  AuthenticatedCheckInsRutCheckoutRouteImport.update({
    id: '/check-ins/rut-checkout',
    path: '/check-ins/rut-checkout',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCheckInsTrainerAttentionRoute =
  AuthenticatedCheckInsTrainerAttentionRouteImport.update({
    id: '/check-ins/trainer-attention',
    path: '/check-ins/trainer-attention',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardAnalyticsRoute =
  AuthenticatedDashboardAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardAttendanceDetailsRoute =
  AuthenticatedDashboardAttendanceDetailsRouteImport.update({
    id: '/attendance-details',
    path: '/attendance-details',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardExitLimitCheckInsRoute =
  AuthenticatedDashboardExitLimitCheckInsRouteImport.update({
    id: '/exit-limit-check-ins',
    path: '/exit-limit-check-ins',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardMembershipExpirationsRoute =
  AuthenticatedDashboardMembershipExpirationsRouteImport.update({
    id: '/membership-expirations',
    path: '/membership-expirations',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardOverviewRoute =
  AuthenticatedDashboardOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardPlansAnalyticsRoute =
  AuthenticatedDashboardPlansAnalyticsRouteImport.update({
    id: '/plans-analytics',
    path: '/plans-analytics',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardRepeatedCheckInsRoute =
  AuthenticatedDashboardRepeatedCheckInsRouteImport.update({
    id: '/repeated-check-ins',
    path: '/repeated-check-ins',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMembershipsIndexRoute =
  AuthenticatedMembershipsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMembershipsRouteRoute,
  } as any)
const AuthenticatedMembershipsCompensationsRoute =
  AuthenticatedMembershipsCompensationsRouteImport.update({
    id: '/compensations',
    path: '/compensations',
    getParentRoute: () => AuthenticatedMembershipsRouteRoute,
  } as any)
const AuthenticatedMembershipsDayPassTypesRoute =
  AuthenticatedMembershipsDayPassTypesRouteImport.update({
    id: '/day-pass-types',
    path: '/day-pass-types',
    getParentRoute: () => AuthenticatedMembershipsRouteRoute,
  } as any)
const AuthenticatedMembershipsManageTypesRoute =
  AuthenticatedMembershipsManageTypesRouteImport.update({
    id: '/manage-types',
    path: '/manage-types',
    getParentRoute: () => AuthenticatedMembershipsRouteRoute,
  } as any)
const AuthenticatedMembershipsWithoutMembershipRoute =
  AuthenticatedMembershipsWithoutMembershipRouteImport.update({
    id: '/without-membership',
    path: '/without-membership',
    getParentRoute: () => AuthenticatedMembershipsRouteRoute,
  } as any)
const AuthenticatedPaymentsIndexRoute =
  AuthenticatedPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPersonalizedPlansIndexRoute =
  AuthenticatedPersonalizedPlansIndexRouteImport.update({
    id: '/personalized-plans/',
    path: '/personalized-plans/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQrCodesIndexRoute =
  AuthenticatedQrCodesIndexRouteImport.update({
    id: '/qr-codes/',
    path: '/qr-codes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsBusinessRoute =
  AuthenticatedSettingsBusinessRouteImport.update({
    id: '/business',
    path: '/business',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsRolesRoute =
  AuthenticatedSettingsRolesRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsTrainerProfileRoute =
  AuthenticatedSettingsTrainerProfileRouteImport.update({
    id: '/trainer-profile',
    path: '/trainer-profile',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSystemCheckInsRoute =
  AuthenticatedSystemCheckInsRouteImport.update({
    id: '/system/check-ins',
    path: '/system/check-ins',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTrainerIndexRoute =
  AuthenticatedTrainerIndexRouteImport.update({
    id: '/trainer/',
    path: '/trainer/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTrainerAssignRoute =
  AuthenticatedTrainerAssignRouteImport.update({
    id: '/trainer/assign',
    path: '/trainer/assign',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTrainerAttentionRoute =
  AuthenticatedTrainerAttentionRouteImport.update({
    id: '/trainer/attention',
    path: '/trainer/attention',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTrainerStudentsRoute =
  AuthenticatedTrainerStudentsRouteImport.update({
    id: '/trainer/students',
    path: '/trainer/students',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTrainersIndexRoute =
  AuthenticatedTrainersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTrainersRouteRoute,
  } as any)
const AuthenticatedTrainersAssignRoute =
  AuthenticatedTrainersAssignRouteImport.update({
    id: '/assign',
    path: '/assign',
    getParentRoute: () => AuthenticatedTrainersRouteRoute,
  } as any)
const AuthenticatedTrainersAttentionReportRoute =
  AuthenticatedTrainersAttentionReportRouteImport.update({
    id: '/attention-report',
    path: '/attention-report',
    getParentRoute: () => AuthenticatedTrainersRouteRoute,
  } as any)
const AuthenticatedTrainersBlockedRoute =
  AuthenticatedTrainersBlockedRouteImport.update({
    id: '/blocked',
    path: '/blocked',
    getParentRoute: () => AuthenticatedTrainersRouteRoute,
  } as any)
const AuthenticatedTrainersNewRoute =
  AuthenticatedTrainersNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedTrainersRouteRoute,
  } as any)
const AuthenticatedTrainersStudentsRoute =
  AuthenticatedTrainersStudentsRouteImport.update({
    id: '/students',
    path: '/students',
    getParentRoute: () => AuthenticatedTrainersRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProfileQrCodeIndexRoute =
  AuthenticatedProfileQrCodeIndexRouteImport.update({
    id: '/profile/qr-code/',
    path: '/profile/qr-code/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/memberships': typeof AuthenticatedMembershipsRouteRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/trainers': typeof AuthenticatedTrainersRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/admin-home': typeof AuthenticatedAdminHomeRoute
  '/member-home': typeof AuthenticatedMemberHomeRoute
  '/my-check-ins': typeof AuthenticatedMyCheckInsRoute
  '/my-membership': typeof AuthenticatedMyMembershipRoute
  '/my-payments': typeof AuthenticatedMyPaymentsRoute
  '/check-ins/by-date': typeof AuthenticatedCheckInsByDateRoute
  '/check-ins/denied-alerts': typeof AuthenticatedCheckInsDeniedAlertsRoute
  '/check-ins/qr': typeof AuthenticatedCheckInsQrRoute
  '/check-ins/qr-checkout': typeof AuthenticatedCheckInsQrCheckoutRoute
  '/check-ins/rut': typeof AuthenticatedCheckInsRutRoute
  '/check-ins/rut-checkout': typeof AuthenticatedCheckInsRutCheckoutRoute
  '/check-ins/trainer-attention': typeof AuthenticatedCheckInsTrainerAttentionRoute
  '/dashboard/analytics': typeof AuthenticatedDashboardAnalyticsRoute
  '/dashboard/attendance-details': typeof AuthenticatedDashboardAttendanceDetailsRoute
  '/dashboard/exit-limit-check-ins': typeof AuthenticatedDashboardExitLimitCheckInsRoute
  '/dashboard/membership-expirations': typeof AuthenticatedDashboardMembershipExpirationsRoute
  '/dashboard/overview': typeof AuthenticatedDashboardOverviewRoute
  '/dashboard/plans-analytics': typeof AuthenticatedDashboardPlansAnalyticsRoute
  '/dashboard/repeated-check-ins': typeof AuthenticatedDashboardRepeatedCheckInsRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/memberships/compensations': typeof AuthenticatedMembershipsCompensationsRoute
  '/memberships/day-pass-types': typeof AuthenticatedMembershipsDayPassTypesRoute
  '/memberships/manage-types': typeof AuthenticatedMembershipsManageTypesRoute
  '/memberships/without-membership': typeof AuthenticatedMembershipsWithoutMembershipRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/business': typeof AuthenticatedSettingsBusinessRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/settings/trainer-profile': typeof AuthenticatedSettingsTrainerProfileRoute
  '/system/check-ins': typeof AuthenticatedSystemCheckInsRoute
  '/trainer/assign': typeof AuthenticatedTrainerAssignRoute
  '/trainer/attention': typeof AuthenticatedTrainerAttentionRoute
  '/trainer/students': typeof AuthenticatedTrainerStudentsRoute
  '/trainers/assign': typeof AuthenticatedTrainersAssignRoute
  '/trainers/attention-report': typeof AuthenticatedTrainersAttentionReportRoute
  '/trainers/blocked': typeof AuthenticatedTrainersBlockedRoute
  '/trainers/new': typeof AuthenticatedTrainersNewRoute
  '/trainers/students': typeof AuthenticatedTrainersStudentsRoute
  '/apps/': typeof AuthenticatedAppsIndexRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/memberships/': typeof AuthenticatedMembershipsIndexRoute
  '/payments/': typeof AuthenticatedPaymentsIndexRoute
  '/personalized-plans/': typeof AuthenticatedPersonalizedPlansIndexRoute
  '/qr-codes/': typeof AuthenticatedQrCodesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/trainer/': typeof AuthenticatedTrainerIndexRoute
  '/trainers/': typeof AuthenticatedTrainersIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/profile/qr-code/': typeof AuthenticatedProfileQrCodeIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/admin-home': typeof AuthenticatedAdminHomeRoute
  '/member-home': typeof AuthenticatedMemberHomeRoute
  '/my-check-ins': typeof AuthenticatedMyCheckInsRoute
  '/my-membership': typeof AuthenticatedMyMembershipRoute
  '/my-payments': typeof AuthenticatedMyPaymentsRoute
  '/': typeof AuthenticatedIndexRoute
  '/check-ins/by-date': typeof AuthenticatedCheckInsByDateRoute
  '/check-ins/denied-alerts': typeof AuthenticatedCheckInsDeniedAlertsRoute
  '/check-ins/qr': typeof AuthenticatedCheckInsQrRoute
  '/check-ins/qr-checkout': typeof AuthenticatedCheckInsQrCheckoutRoute
  '/check-ins/rut': typeof AuthenticatedCheckInsRutRoute
  '/check-ins/rut-checkout': typeof AuthenticatedCheckInsRutCheckoutRoute
  '/check-ins/trainer-attention': typeof AuthenticatedCheckInsTrainerAttentionRoute
  '/dashboard/analytics': typeof AuthenticatedDashboardAnalyticsRoute
  '/dashboard/attendance-details': typeof AuthenticatedDashboardAttendanceDetailsRoute
  '/dashboard/exit-limit-check-ins': typeof AuthenticatedDashboardExitLimitCheckInsRoute
  '/dashboard/membership-expirations': typeof AuthenticatedDashboardMembershipExpirationsRoute
  '/dashboard/overview': typeof AuthenticatedDashboardOverviewRoute
  '/dashboard/plans-analytics': typeof AuthenticatedDashboardPlansAnalyticsRoute
  '/dashboard/repeated-check-ins': typeof AuthenticatedDashboardRepeatedCheckInsRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/memberships/compensations': typeof AuthenticatedMembershipsCompensationsRoute
  '/memberships/day-pass-types': typeof AuthenticatedMembershipsDayPassTypesRoute
  '/memberships/manage-types': typeof AuthenticatedMembershipsManageTypesRoute
  '/memberships/without-membership': typeof AuthenticatedMembershipsWithoutMembershipRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/business': typeof AuthenticatedSettingsBusinessRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/settings/trainer-profile': typeof AuthenticatedSettingsTrainerProfileRoute
  '/system/check-ins': typeof AuthenticatedSystemCheckInsRoute
  '/trainer/assign': typeof AuthenticatedTrainerAssignRoute
  '/trainer/attention': typeof AuthenticatedTrainerAttentionRoute
  '/trainer/students': typeof AuthenticatedTrainerStudentsRoute
  '/trainers/assign': typeof AuthenticatedTrainersAssignRoute
  '/trainers/attention-report': typeof AuthenticatedTrainersAttentionReportRoute
  '/trainers/blocked': typeof AuthenticatedTrainersBlockedRoute
  '/trainers/new': typeof AuthenticatedTrainersNewRoute
  '/trainers/students': typeof AuthenticatedTrainersStudentsRoute
  '/apps': typeof AuthenticatedAppsIndexRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/memberships': typeof AuthenticatedMembershipsIndexRoute
  '/payments': typeof AuthenticatedPaymentsIndexRoute
  '/personalized-plans': typeof AuthenticatedPersonalizedPlansIndexRoute
  '/qr-codes': typeof AuthenticatedQrCodesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/trainer': typeof AuthenticatedTrainerIndexRoute
  '/trainers': typeof AuthenticatedTrainersIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/profile/qr-code': typeof AuthenticatedProfileQrCodeIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/_authenticated/memberships': typeof AuthenticatedMembershipsRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/trainers': typeof AuthenticatedTrainersRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/admin-home': typeof AuthenticatedAdminHomeRoute
  '/_authenticated/member-home': typeof AuthenticatedMemberHomeRoute
  '/_authenticated/my-check-ins': typeof AuthenticatedMyCheckInsRoute
  '/_authenticated/my-membership': typeof AuthenticatedMyMembershipRoute
  '/_authenticated/my-payments': typeof AuthenticatedMyPaymentsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/check-ins/by-date': typeof AuthenticatedCheckInsByDateRoute
  '/_authenticated/check-ins/denied-alerts': typeof AuthenticatedCheckInsDeniedAlertsRoute
  '/_authenticated/check-ins/qr': typeof AuthenticatedCheckInsQrRoute
  '/_authenticated/check-ins/qr-checkout': typeof AuthenticatedCheckInsQrCheckoutRoute
  '/_authenticated/check-ins/rut': typeof AuthenticatedCheckInsRutRoute
  '/_authenticated/check-ins/rut-checkout': typeof AuthenticatedCheckInsRutCheckoutRoute
  '/_authenticated/check-ins/trainer-attention': typeof AuthenticatedCheckInsTrainerAttentionRoute
  '/_authenticated/dashboard/analytics': typeof AuthenticatedDashboardAnalyticsRoute
  '/_authenticated/dashboard/attendance-details': typeof AuthenticatedDashboardAttendanceDetailsRoute
  '/_authenticated/dashboard/exit-limit-check-ins': typeof AuthenticatedDashboardExitLimitCheckInsRoute
  '/_authenticated/dashboard/membership-expirations': typeof AuthenticatedDashboardMembershipExpirationsRoute
  '/_authenticated/dashboard/overview': typeof AuthenticatedDashboardOverviewRoute
  '/_authenticated/dashboard/plans-analytics': typeof AuthenticatedDashboardPlansAnalyticsRoute
  '/_authenticated/dashboard/repeated-check-ins': typeof AuthenticatedDashboardRepeatedCheckInsRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/memberships/compensations': typeof AuthenticatedMembershipsCompensationsRoute
  '/_authenticated/memberships/day-pass-types': typeof AuthenticatedMembershipsDayPassTypesRoute
  '/_authenticated/memberships/manage-types': typeof AuthenticatedMembershipsManageTypesRoute
  '/_authenticated/memberships/without-membership': typeof AuthenticatedMembershipsWithoutMembershipRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/business': typeof AuthenticatedSettingsBusinessRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/roles': typeof AuthenticatedSettingsRolesRoute
  '/_authenticated/settings/trainer-profile': typeof AuthenticatedSettingsTrainerProfileRoute
  '/_authenticated/system/check-ins': typeof AuthenticatedSystemCheckInsRoute
  '/_authenticated/trainer/assign': typeof AuthenticatedTrainerAssignRoute
  '/_authenticated/trainer/attention': typeof AuthenticatedTrainerAttentionRoute
  '/_authenticated/trainer/students': typeof AuthenticatedTrainerStudentsRoute
  '/_authenticated/trainers/assign': typeof AuthenticatedTrainersAssignRoute
  '/_authenticated/trainers/attention-report': typeof AuthenticatedTrainersAttentionReportRoute
  '/_authenticated/trainers/blocked': typeof AuthenticatedTrainersBlockedRoute
  '/_authenticated/trainers/new': typeof AuthenticatedTrainersNewRoute
  '/_authenticated/trainers/students': typeof AuthenticatedTrainersStudentsRoute
  '/_authenticated/apps/': typeof AuthenticatedAppsIndexRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/memberships/': typeof AuthenticatedMembershipsIndexRoute
  '/_authenticated/payments/': typeof AuthenticatedPaymentsIndexRoute
  '/_authenticated/personalized-plans/': typeof AuthenticatedPersonalizedPlansIndexRoute
  '/_authenticated/qr-codes/': typeof AuthenticatedQrCodesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/trainer/': typeof AuthenticatedTrainerIndexRoute
  '/_authenticated/trainers/': typeof AuthenticatedTrainersIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/profile/qr-code/': typeof AuthenticatedProfileQrCodeIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/memberships'
    | '/settings'
    | '/trainers'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/admin-home'
    | '/member-home'
    | '/my-check-ins'
    | '/my-membership'
    | '/my-payments'
    | '/check-ins/by-date'
    | '/check-ins/denied-alerts'
    | '/check-ins/qr'
    | '/check-ins/qr-checkout'
    | '/check-ins/rut'
    | '/check-ins/rut-checkout'
    | '/check-ins/trainer-attention'
    | '/dashboard/analytics'
    | '/dashboard/attendance-details'
    | '/dashboard/exit-limit-check-ins'
    | '/dashboard/membership-expirations'
    | '/dashboard/overview'
    | '/dashboard/plans-analytics'
    | '/dashboard/repeated-check-ins'
    | '/errors/$error'
    | '/memberships/compensations'
    | '/memberships/day-pass-types'
    | '/memberships/manage-types'
    | '/memberships/without-membership'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/business'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/roles'
    | '/settings/trainer-profile'
    | '/system/check-ins'
    | '/trainer/assign'
    | '/trainer/attention'
    | '/trainer/students'
    | '/trainers/assign'
    | '/trainers/attention-report'
    | '/trainers/blocked'
    | '/trainers/new'
    | '/trainers/students'
    | '/apps/'
    | '/chats/'
    | '/dashboard/'
    | '/help-center/'
    | '/memberships/'
    | '/payments/'
    | '/personalized-plans/'
    | '/qr-codes/'
    | '/settings/'
    | '/tasks/'
    | '/trainer/'
    | '/trainers/'
    | '/users/'
    | '/profile/qr-code/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/verify-email'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/admin-home'
    | '/member-home'
    | '/my-check-ins'
    | '/my-membership'
    | '/my-payments'
    | '/'
    | '/check-ins/by-date'
    | '/check-ins/denied-alerts'
    | '/check-ins/qr'
    | '/check-ins/qr-checkout'
    | '/check-ins/rut'
    | '/check-ins/rut-checkout'
    | '/check-ins/trainer-attention'
    | '/dashboard/analytics'
    | '/dashboard/attendance-details'
    | '/dashboard/exit-limit-check-ins'
    | '/dashboard/membership-expirations'
    | '/dashboard/overview'
    | '/dashboard/plans-analytics'
    | '/dashboard/repeated-check-ins'
    | '/errors/$error'
    | '/memberships/compensations'
    | '/memberships/day-pass-types'
    | '/memberships/manage-types'
    | '/memberships/without-membership'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/business'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/roles'
    | '/settings/trainer-profile'
    | '/system/check-ins'
    | '/trainer/assign'
    | '/trainer/attention'
    | '/trainer/students'
    | '/trainers/assign'
    | '/trainers/attention-report'
    | '/trainers/blocked'
    | '/trainers/new'
    | '/trainers/students'
    | '/apps'
    | '/chats'
    | '/dashboard'
    | '/help-center'
    | '/memberships'
    | '/payments'
    | '/personalized-plans'
    | '/qr-codes'
    | '/settings'
    | '/tasks'
    | '/trainer'
    | '/trainers'
    | '/users'
    | '/profile/qr-code'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/dashboard'
    | '/_authenticated/memberships'
    | '/_authenticated/settings'
    | '/_authenticated/trainers'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/(auth)/verify-email'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/admin-home'
    | '/_authenticated/member-home'
    | '/_authenticated/my-check-ins'
    | '/_authenticated/my-membership'
    | '/_authenticated/my-payments'
    | '/_authenticated/'
    | '/_authenticated/check-ins/by-date'
    | '/_authenticated/check-ins/denied-alerts'
    | '/_authenticated/check-ins/qr'
    | '/_authenticated/check-ins/qr-checkout'
    | '/_authenticated/check-ins/rut'
    | '/_authenticated/check-ins/rut-checkout'
    | '/_authenticated/check-ins/trainer-attention'
    | '/_authenticated/dashboard/analytics'
    | '/_authenticated/dashboard/attendance-details'
    | '/_authenticated/dashboard/exit-limit-check-ins'
    | '/_authenticated/dashboard/membership-expirations'
    | '/_authenticated/dashboard/overview'
    | '/_authenticated/dashboard/plans-analytics'
    | '/_authenticated/dashboard/repeated-check-ins'
    | '/_authenticated/errors/$error'
    | '/_authenticated/memberships/compensations'
    | '/_authenticated/memberships/day-pass-types'
    | '/_authenticated/memberships/manage-types'
    | '/_authenticated/memberships/without-membership'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/business'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/roles'
    | '/_authenticated/settings/trainer-profile'
    | '/_authenticated/system/check-ins'
    | '/_authenticated/trainer/assign'
    | '/_authenticated/trainer/attention'
    | '/_authenticated/trainer/students'
    | '/_authenticated/trainers/assign'
    | '/_authenticated/trainers/attention-report'
    | '/_authenticated/trainers/blocked'
    | '/_authenticated/trainers/new'
    | '/_authenticated/trainers/students'
    | '/_authenticated/apps/'
    | '/_authenticated/chats/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/help-center/'
    | '/_authenticated/memberships/'
    | '/_authenticated/payments/'
    | '/_authenticated/personalized-plans/'
    | '/_authenticated/qr-codes/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/trainer/'
    | '/_authenticated/trainers/'
    | '/_authenticated/users/'
    | '/_authenticated/profile/qr-code/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/admin-home': {
      id: '/_authenticated/admin-home'
      path: '/admin-home'
      fullPath: '/admin-home'
      preLoaderRoute: typeof AuthenticatedAdminHomeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/member-home': {
      id: '/_authenticated/member-home'
      path: '/member-home'
      fullPath: '/member-home'
      preLoaderRoute: typeof AuthenticatedMemberHomeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/memberships': {
      id: '/_authenticated/memberships'
      path: '/memberships'
      fullPath: '/memberships'
      preLoaderRoute: typeof AuthenticatedMembershipsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-check-ins': {
      id: '/_authenticated/my-check-ins'
      path: '/my-check-ins'
      fullPath: '/my-check-ins'
      preLoaderRoute: typeof AuthenticatedMyCheckInsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-membership': {
      id: '/_authenticated/my-membership'
      path: '/my-membership'
      fullPath: '/my-membership'
      preLoaderRoute: typeof AuthenticatedMyMembershipRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/my-payments': {
      id: '/_authenticated/my-payments'
      path: '/my-payments'
      fullPath: '/my-payments'
      preLoaderRoute: typeof AuthenticatedMyPaymentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainers': {
      id: '/_authenticated/trainers'
      path: '/trainers'
      fullPath: '/trainers'
      preLoaderRoute: typeof AuthenticatedTrainersRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/apps/': {
      id: '/_authenticated/apps/'
      path: '/apps'
      fullPath: '/apps/'
      preLoaderRoute: typeof AuthenticatedAppsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/by-date': {
      id: '/_authenticated/check-ins/by-date'
      path: '/check-ins/by-date'
      fullPath: '/check-ins/by-date'
      preLoaderRoute: typeof AuthenticatedCheckInsByDateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/denied-alerts': {
      id: '/_authenticated/check-ins/denied-alerts'
      path: '/check-ins/denied-alerts'
      fullPath: '/check-ins/denied-alerts'
      preLoaderRoute: typeof AuthenticatedCheckInsDeniedAlertsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/qr': {
      id: '/_authenticated/check-ins/qr'
      path: '/check-ins/qr'
      fullPath: '/check-ins/qr'
      preLoaderRoute: typeof AuthenticatedCheckInsQrRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/qr-checkout': {
      id: '/_authenticated/check-ins/qr-checkout'
      path: '/check-ins/qr-checkout'
      fullPath: '/check-ins/qr-checkout'
      preLoaderRoute: typeof AuthenticatedCheckInsQrCheckoutRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/rut': {
      id: '/_authenticated/check-ins/rut'
      path: '/check-ins/rut'
      fullPath: '/check-ins/rut'
      preLoaderRoute: typeof AuthenticatedCheckInsRutRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/rut-checkout': {
      id: '/_authenticated/check-ins/rut-checkout'
      path: '/check-ins/rut-checkout'
      fullPath: '/check-ins/rut-checkout'
      preLoaderRoute: typeof AuthenticatedCheckInsRutCheckoutRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/check-ins/trainer-attention': {
      id: '/_authenticated/check-ins/trainer-attention'
      path: '/check-ins/trainer-attention'
      fullPath: '/check-ins/trainer-attention'
      preLoaderRoute: typeof AuthenticatedCheckInsTrainerAttentionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/analytics': {
      id: '/_authenticated/dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof AuthenticatedDashboardAnalyticsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/attendance-details': {
      id: '/_authenticated/dashboard/attendance-details'
      path: '/attendance-details'
      fullPath: '/dashboard/attendance-details'
      preLoaderRoute: typeof AuthenticatedDashboardAttendanceDetailsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/exit-limit-check-ins': {
      id: '/_authenticated/dashboard/exit-limit-check-ins'
      path: '/exit-limit-check-ins'
      fullPath: '/dashboard/exit-limit-check-ins'
      preLoaderRoute: typeof AuthenticatedDashboardExitLimitCheckInsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/membership-expirations': {
      id: '/_authenticated/dashboard/membership-expirations'
      path: '/membership-expirations'
      fullPath: '/dashboard/membership-expirations'
      preLoaderRoute: typeof AuthenticatedDashboardMembershipExpirationsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/overview': {
      id: '/_authenticated/dashboard/overview'
      path: '/overview'
      fullPath: '/dashboard/overview'
      preLoaderRoute: typeof AuthenticatedDashboardOverviewRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/plans-analytics': {
      id: '/_authenticated/dashboard/plans-analytics'
      path: '/plans-analytics'
      fullPath: '/dashboard/plans-analytics'
      preLoaderRoute: typeof AuthenticatedDashboardPlansAnalyticsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/repeated-check-ins': {
      id: '/_authenticated/dashboard/repeated-check-ins'
      path: '/repeated-check-ins'
      fullPath: '/dashboard/repeated-check-ins'
      preLoaderRoute: typeof AuthenticatedDashboardRepeatedCheckInsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/memberships/': {
      id: '/_authenticated/memberships/'
      path: '/'
      fullPath: '/memberships/'
      preLoaderRoute: typeof AuthenticatedMembershipsIndexRouteImport
      parentRoute: typeof AuthenticatedMembershipsRouteRoute
    }
    '/_authenticated/memberships/compensations': {
      id: '/_authenticated/memberships/compensations'
      path: '/compensations'
      fullPath: '/memberships/compensations'
      preLoaderRoute: typeof AuthenticatedMembershipsCompensationsRouteImport
      parentRoute: typeof AuthenticatedMembershipsRouteRoute
    }
    '/_authenticated/memberships/day-pass-types': {
      id: '/_authenticated/memberships/day-pass-types'
      path: '/day-pass-types'
      fullPath: '/memberships/day-pass-types'
      preLoaderRoute: typeof AuthenticatedMembershipsDayPassTypesRouteImport
      parentRoute: typeof AuthenticatedMembershipsRouteRoute
    }
    '/_authenticated/memberships/manage-types': {
      id: '/_authenticated/memberships/manage-types'
      path: '/manage-types'
      fullPath: '/memberships/manage-types'
      preLoaderRoute: typeof AuthenticatedMembershipsManageTypesRouteImport
      parentRoute: typeof AuthenticatedMembershipsRouteRoute
    }
    '/_authenticated/memberships/without-membership': {
      id: '/_authenticated/memberships/without-membership'
      path: '/without-membership'
      fullPath: '/memberships/without-membership'
      preLoaderRoute: typeof AuthenticatedMembershipsWithoutMembershipRouteImport
      parentRoute: typeof AuthenticatedMembershipsRouteRoute
    }
    '/_authenticated/payments/': {
      id: '/_authenticated/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AuthenticatedPaymentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/personalized-plans/': {
      id: '/_authenticated/personalized-plans/'
      path: '/personalized-plans'
      fullPath: '/personalized-plans/'
      preLoaderRoute: typeof AuthenticatedPersonalizedPlansIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/qr-codes/': {
      id: '/_authenticated/qr-codes/'
      path: '/qr-codes'
      fullPath: '/qr-codes/'
      preLoaderRoute: typeof AuthenticatedQrCodesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/business': {
      id: '/_authenticated/settings/business'
      path: '/business'
      fullPath: '/settings/business'
      preLoaderRoute: typeof AuthenticatedSettingsBusinessRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/roles': {
      id: '/_authenticated/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AuthenticatedSettingsRolesRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/trainer-profile': {
      id: '/_authenticated/settings/trainer-profile'
      path: '/trainer-profile'
      fullPath: '/settings/trainer-profile'
      preLoaderRoute: typeof AuthenticatedSettingsTrainerProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/system/check-ins': {
      id: '/_authenticated/system/check-ins'
      path: '/system/check-ins'
      fullPath: '/system/check-ins'
      preLoaderRoute: typeof AuthenticatedSystemCheckInsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainer/': {
      id: '/_authenticated/trainer/'
      path: '/trainer'
      fullPath: '/trainer/'
      preLoaderRoute: typeof AuthenticatedTrainerIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainer/assign': {
      id: '/_authenticated/trainer/assign'
      path: '/trainer/assign'
      fullPath: '/trainer/assign'
      preLoaderRoute: typeof AuthenticatedTrainerAssignRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainer/attention': {
      id: '/_authenticated/trainer/attention'
      path: '/trainer/attention'
      fullPath: '/trainer/attention'
      preLoaderRoute: typeof AuthenticatedTrainerAttentionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainer/students': {
      id: '/_authenticated/trainer/students'
      path: '/trainer/students'
      fullPath: '/trainer/students'
      preLoaderRoute: typeof AuthenticatedTrainerStudentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/trainers/': {
      id: '/_authenticated/trainers/'
      path: '/'
      fullPath: '/trainers/'
      preLoaderRoute: typeof AuthenticatedTrainersIndexRouteImport
      parentRoute: typeof AuthenticatedTrainersRouteRoute
    }
    '/_authenticated/trainers/assign': {
      id: '/_authenticated/trainers/assign'
      path: '/assign'
      fullPath: '/trainers/assign'
      preLoaderRoute: typeof AuthenticatedTrainersAssignRouteImport
      parentRoute: typeof AuthenticatedTrainersRouteRoute
    }
    '/_authenticated/trainers/attention-report': {
      id: '/_authenticated/trainers/attention-report'
      path: '/attention-report'
      fullPath: '/trainers/attention-report'
      preLoaderRoute: typeof AuthenticatedTrainersAttentionReportRouteImport
      parentRoute: typeof AuthenticatedTrainersRouteRoute
    }
    '/_authenticated/trainers/blocked': {
      id: '/_authenticated/trainers/blocked'
      path: '/blocked'
      fullPath: '/trainers/blocked'
      preLoaderRoute: typeof AuthenticatedTrainersBlockedRouteImport
      parentRoute: typeof AuthenticatedTrainersRouteRoute
    }
    '/_authenticated/trainers/new': {
      id: '/_authenticated/trainers/new'
      path: '/new'
      fullPath: '/trainers/new'
      preLoaderRoute: typeof AuthenticatedTrainersNewRouteImport
      parentRoute: typeof AuthenticatedTrainersRouteRoute
    }
    '/_authenticated/trainers/students': {
      id: '/_authenticated/trainers/students'
      path: '/students'
      fullPath: '/trainers/students'
      preLoaderRoute: typeof AuthenticatedTrainersStudentsRouteImport
      parentRoute: typeof AuthenticatedTrainersRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/qr-code/': {
      id: '/_authenticated/profile/qr-code/'
      path: '/profile/qr-code'
      fullPath: '/profile/qr-code/'
      preLoaderRoute: typeof AuthenticatedProfileQrCodeIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedDashboardRouteRouteChildren {
  AuthenticatedDashboardAnalyticsRoute: typeof AuthenticatedDashboardAnalyticsRoute
  AuthenticatedDashboardAttendanceDetailsRoute: typeof AuthenticatedDashboardAttendanceDetailsRoute
  AuthenticatedDashboardExitLimitCheckInsRoute: typeof AuthenticatedDashboardExitLimitCheckInsRoute
  AuthenticatedDashboardMembershipExpirationsRoute: typeof AuthenticatedDashboardMembershipExpirationsRoute
  AuthenticatedDashboardOverviewRoute: typeof AuthenticatedDashboardOverviewRoute
  AuthenticatedDashboardPlansAnalyticsRoute: typeof AuthenticatedDashboardPlansAnalyticsRoute
  AuthenticatedDashboardRepeatedCheckInsRoute: typeof AuthenticatedDashboardRepeatedCheckInsRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
}

const AuthenticatedDashboardRouteRouteChildren: AuthenticatedDashboardRouteRouteChildren =
  {
    AuthenticatedDashboardAnalyticsRoute: AuthenticatedDashboardAnalyticsRoute,
    AuthenticatedDashboardAttendanceDetailsRoute:
      AuthenticatedDashboardAttendanceDetailsRoute,
    AuthenticatedDashboardExitLimitCheckInsRoute:
      AuthenticatedDashboardExitLimitCheckInsRoute,
    AuthenticatedDashboardMembershipExpirationsRoute:
      AuthenticatedDashboardMembershipExpirationsRoute,
    AuthenticatedDashboardOverviewRoute: AuthenticatedDashboardOverviewRoute,
    AuthenticatedDashboardPlansAnalyticsRoute:
      AuthenticatedDashboardPlansAnalyticsRoute,
    AuthenticatedDashboardRepeatedCheckInsRoute:
      AuthenticatedDashboardRepeatedCheckInsRoute,
    AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  }

const AuthenticatedDashboardRouteRouteWithChildren =
  AuthenticatedDashboardRouteRoute._addFileChildren(
    AuthenticatedDashboardRouteRouteChildren,
  )

interface AuthenticatedMembershipsRouteRouteChildren {
  AuthenticatedMembershipsCompensationsRoute: typeof AuthenticatedMembershipsCompensationsRoute
  AuthenticatedMembershipsDayPassTypesRoute: typeof AuthenticatedMembershipsDayPassTypesRoute
  AuthenticatedMembershipsManageTypesRoute: typeof AuthenticatedMembershipsManageTypesRoute
  AuthenticatedMembershipsWithoutMembershipRoute: typeof AuthenticatedMembershipsWithoutMembershipRoute
  AuthenticatedMembershipsIndexRoute: typeof AuthenticatedMembershipsIndexRoute
}

const AuthenticatedMembershipsRouteRouteChildren: AuthenticatedMembershipsRouteRouteChildren =
  {
    AuthenticatedMembershipsCompensationsRoute:
      AuthenticatedMembershipsCompensationsRoute,
    AuthenticatedMembershipsDayPassTypesRoute:
      AuthenticatedMembershipsDayPassTypesRoute,
    AuthenticatedMembershipsManageTypesRoute:
      AuthenticatedMembershipsManageTypesRoute,
    AuthenticatedMembershipsWithoutMembershipRoute:
      AuthenticatedMembershipsWithoutMembershipRoute,
    AuthenticatedMembershipsIndexRoute: AuthenticatedMembershipsIndexRoute,
  }

const AuthenticatedMembershipsRouteRouteWithChildren =
  AuthenticatedMembershipsRouteRoute._addFileChildren(
    AuthenticatedMembershipsRouteRouteChildren,
  )

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsBusinessRoute: typeof AuthenticatedSettingsBusinessRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsRolesRoute: typeof AuthenticatedSettingsRolesRoute
  AuthenticatedSettingsTrainerProfileRoute: typeof AuthenticatedSettingsTrainerProfileRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsBusinessRoute: AuthenticatedSettingsBusinessRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsRolesRoute: AuthenticatedSettingsRolesRoute,
    AuthenticatedSettingsTrainerProfileRoute:
      AuthenticatedSettingsTrainerProfileRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedTrainersRouteRouteChildren {
  AuthenticatedTrainersAssignRoute: typeof AuthenticatedTrainersAssignRoute
  AuthenticatedTrainersAttentionReportRoute: typeof AuthenticatedTrainersAttentionReportRoute
  AuthenticatedTrainersBlockedRoute: typeof AuthenticatedTrainersBlockedRoute
  AuthenticatedTrainersNewRoute: typeof AuthenticatedTrainersNewRoute
  AuthenticatedTrainersStudentsRoute: typeof AuthenticatedTrainersStudentsRoute
  AuthenticatedTrainersIndexRoute: typeof AuthenticatedTrainersIndexRoute
}

const AuthenticatedTrainersRouteRouteChildren: AuthenticatedTrainersRouteRouteChildren =
  {
    AuthenticatedTrainersAssignRoute: AuthenticatedTrainersAssignRoute,
    AuthenticatedTrainersAttentionReportRoute:
      AuthenticatedTrainersAttentionReportRoute,
    AuthenticatedTrainersBlockedRoute: AuthenticatedTrainersBlockedRoute,
    AuthenticatedTrainersNewRoute: AuthenticatedTrainersNewRoute,
    AuthenticatedTrainersStudentsRoute: AuthenticatedTrainersStudentsRoute,
    AuthenticatedTrainersIndexRoute: AuthenticatedTrainersIndexRoute,
  }

const AuthenticatedTrainersRouteRouteWithChildren =
  AuthenticatedTrainersRouteRoute._addFileChildren(
    AuthenticatedTrainersRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedDashboardRouteRoute: typeof AuthenticatedDashboardRouteRouteWithChildren
  AuthenticatedMembershipsRouteRoute: typeof AuthenticatedMembershipsRouteRouteWithChildren
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedTrainersRouteRoute: typeof AuthenticatedTrainersRouteRouteWithChildren
  AuthenticatedAdminHomeRoute: typeof AuthenticatedAdminHomeRoute
  AuthenticatedMemberHomeRoute: typeof AuthenticatedMemberHomeRoute
  AuthenticatedMyCheckInsRoute: typeof AuthenticatedMyCheckInsRoute
  AuthenticatedMyMembershipRoute: typeof AuthenticatedMyMembershipRoute
  AuthenticatedMyPaymentsRoute: typeof AuthenticatedMyPaymentsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCheckInsByDateRoute: typeof AuthenticatedCheckInsByDateRoute
  AuthenticatedCheckInsDeniedAlertsRoute: typeof AuthenticatedCheckInsDeniedAlertsRoute
  AuthenticatedCheckInsQrRoute: typeof AuthenticatedCheckInsQrRoute
  AuthenticatedCheckInsQrCheckoutRoute: typeof AuthenticatedCheckInsQrCheckoutRoute
  AuthenticatedCheckInsRutRoute: typeof AuthenticatedCheckInsRutRoute
  AuthenticatedCheckInsRutCheckoutRoute: typeof AuthenticatedCheckInsRutCheckoutRoute
  AuthenticatedCheckInsTrainerAttentionRoute: typeof AuthenticatedCheckInsTrainerAttentionRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedSystemCheckInsRoute: typeof AuthenticatedSystemCheckInsRoute
  AuthenticatedTrainerAssignRoute: typeof AuthenticatedTrainerAssignRoute
  AuthenticatedTrainerAttentionRoute: typeof AuthenticatedTrainerAttentionRoute
  AuthenticatedTrainerStudentsRoute: typeof AuthenticatedTrainerStudentsRoute
  AuthenticatedAppsIndexRoute: typeof AuthenticatedAppsIndexRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedPaymentsIndexRoute: typeof AuthenticatedPaymentsIndexRoute
  AuthenticatedPersonalizedPlansIndexRoute: typeof AuthenticatedPersonalizedPlansIndexRoute
  AuthenticatedQrCodesIndexRoute: typeof AuthenticatedQrCodesIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedTrainerIndexRoute: typeof AuthenticatedTrainerIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedProfileQrCodeIndexRoute: typeof AuthenticatedProfileQrCodeIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRouteRoute:
    AuthenticatedDashboardRouteRouteWithChildren,
  AuthenticatedMembershipsRouteRoute:
    AuthenticatedMembershipsRouteRouteWithChildren,
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedTrainersRouteRoute: AuthenticatedTrainersRouteRouteWithChildren,
  AuthenticatedAdminHomeRoute: AuthenticatedAdminHomeRoute,
  AuthenticatedMemberHomeRoute: AuthenticatedMemberHomeRoute,
  AuthenticatedMyCheckInsRoute: AuthenticatedMyCheckInsRoute,
  AuthenticatedMyMembershipRoute: AuthenticatedMyMembershipRoute,
  AuthenticatedMyPaymentsRoute: AuthenticatedMyPaymentsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCheckInsByDateRoute: AuthenticatedCheckInsByDateRoute,
  AuthenticatedCheckInsDeniedAlertsRoute:
    AuthenticatedCheckInsDeniedAlertsRoute,
  AuthenticatedCheckInsQrRoute: AuthenticatedCheckInsQrRoute,
  AuthenticatedCheckInsQrCheckoutRoute: AuthenticatedCheckInsQrCheckoutRoute,
  AuthenticatedCheckInsRutRoute: AuthenticatedCheckInsRutRoute,
  AuthenticatedCheckInsRutCheckoutRoute: AuthenticatedCheckInsRutCheckoutRoute,
  AuthenticatedCheckInsTrainerAttentionRoute:
    AuthenticatedCheckInsTrainerAttentionRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedSystemCheckInsRoute: AuthenticatedSystemCheckInsRoute,
  AuthenticatedTrainerAssignRoute: AuthenticatedTrainerAssignRoute,
  AuthenticatedTrainerAttentionRoute: AuthenticatedTrainerAttentionRoute,
  AuthenticatedTrainerStudentsRoute: AuthenticatedTrainerStudentsRoute,
  AuthenticatedAppsIndexRoute: AuthenticatedAppsIndexRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedPaymentsIndexRoute: AuthenticatedPaymentsIndexRoute,
  AuthenticatedPersonalizedPlansIndexRoute:
    AuthenticatedPersonalizedPlansIndexRoute,
  AuthenticatedQrCodesIndexRoute: AuthenticatedQrCodesIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedTrainerIndexRoute: AuthenticatedTrainerIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedProfileQrCodeIndexRoute: AuthenticatedProfileQrCodeIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
